<script>
    export default {
        filters: {
            moneyLocaleString: function (value) {
                if (value==null) return null
                return value.toLocaleString();
            }
        },
        data: () => ({

            app_version: g_version,
            app_system_name: g_system_name,
            app_user_cd: g_user_cd,
            app_user_nm: g_user_nm,
            app_user_grp: g_user_grp,
            app_authority: g_authority,
            app_errmessage: g_errmessage,

            //汎用的なルール
            rules: {
                required: v => !!v || '必須',
                max(maxNum) {
                    return v => (v || '').toString().length <= maxNum || `${maxNum}文字以内で入力してください。`;
                },

                existCheck: true,
                target:'',
                Exist() {
                    return this.existCheck == true || `${this.target}が存在しません。`;
                },
                isHanEisu() {
                    return v => v.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) || '半角英数で入力してください。';
                }
            },

            itemsPerPageAllOption: {
                itemsPerPage: -1
            },

            //CSV出力モデル 最終的なリクエスト用
            csvRequestModel: {
                controller_nm: '',
                csv_setting: null,
            },

            exp_csv_dialog: {
                is_open: false,
                csvItem: null,
                title: '',
                type_cd: '',
                type_nm: '',
            },
             csvNewItem: {
                ninushi_cd: '',
                company_cd: '',
                ware_cd: '',
                menu_grp_id: '',
                screen_id: '',
                job_id: '',
                csv_nm: '',
                csv_layout: null ,
                skip_type:'',
                skip_flg: false,
                skip: false,
                header_out_flg: false,
                upload_file: null
            },
            csvNewSyukkaItem: {
                ninushi_cd: '',
                company_cd: '',
                ware_cd: '',
                menu_grp_id: '',
                screen_id: '',
                job_id: '',
                csv_nm: '',
                csv_layout: null,
                skip_type: '',
                skip: false,
                header_out_flg: false,
                upload_file: null,
                syori_kbn: '',
                fusoku: false,
                out_kbn: '',
                out_sch_date: '',
                limit_time: ''
            },
        }),

        methods: {

            //コードカテゴリからキー指定でリスト取得
            async getCodeCategory(key) {

                try {

                    var param = new URLSearchParams();
                    param.append('param', JSON.stringify(key));

                    let res = await this.axios_post('/CommonComponents/GetCodeCategory', param);
                    if (res.data.status !== "OK") {

                        this.msg_error_dialog(res.data.messages);
                        return null;

                    }

                    return res.data.category;

                } catch (e) {

                    this.msg_error_dialog(e);
                    return null;

                }

            },

            async GetPerson() {
                try {
                    this.Loading(true);
                    console.log('GetPerson');
                    var param = new URLSearchParams();
                    let res = await this.axios_post('/CommonComponents/GetPerson', param);

                    if (res.data.status !== "OK") {

                        this.msg_error_dialog(res.data.messages);
                        return;

                    }
                    console.log(res.data.data_list);
                    return res.data.data_list;


                } catch (err) {
                    console.log(err);
                } finally {
                    this.Loading(false);
                }
            },

            async GetSupplier() {
                try {
                    this.Loading(true);
                    console.log('GetSupplier');
                    var param = new URLSearchParams();
                    let res = await this.axios_post('/CommonComponents/GetSupplier', param);

                    if (res.data.status !== "OK") {

                        this.msg_error_dialog(res.data.messages);
                        return;

                    }
                    console.log(res.data.data_list);
                    return res.data.data_list;


                } catch (err) {
                    console.log(err);
                } finally {
                    this.Loading(false);
                }
            },

            //コード検索時の存在チェック
            Exist(...args) {
                this.rules.existCheck = args[0];
                this.rules.target = args[1];
            },
            Loading(isLoading) {
                this.$store.commit('setMasterLoading', isLoading);
            },

            DownloadPDF(file, base64) {
                const win = window.open('about:blank', '_blank');
                let html = '';

                html += '<html><title>' + file + '</title>';
                html += '<body style="margin:0!important">';
                html += '<embed download="" width="100%" height="100%" src="data:application/pdf;base64,' + base64 + '" type="application/pdf" />';
                html += '</body>';
                html += '</html>';
                win.document.write(html);
            },

            //プライマリーカラーを動的に設定する
            setPrimary(color) {
                this.$vuetify.theme.themes.light.primary = color;
                this.$vuetify.theme.themes.dark.primary = color;
            },

            dateFormat(date) {
                if (date.length == 8) {
                    var d = date;
                    const yyyy = d.slice(0, 4);
                    const mm = d.slice(4, 6);
                    const dd = d.slice(6);
                    return yyyy + '/' + mm + '/' + dd;
                }
            },

        }
    };
</script>
